import { IconButton, styled, Tooltip } from "@mui/material";
import { FC } from "react";
import { Link } from "react-router-dom";
import useLocales from "../../hooks/useLocales";
import EditIcon from "@mui/icons-material/Edit";

interface IAdornment {
  path: string;
}

const LinkEdit = styled(IconButton)({
  boxShadow: "none",
  textTransform: "none",
  fontSize: 16,
  color: "#853EF8",
  "&:hover": {
    backgroundColor: "transparent",
    borderColor: "#0062cc",
    boxShadow: "none",
  },
  "&:active": {
    boxShadow: "none",
    backgroundColor: "#0062cc",
    borderColor: "#005cbf",
  },
  "&:focus": {
    boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)",
  },
});

const AdornmentLinkButton: FC<IAdornment> = (props) => {
  const { translate } = useLocales();
  return (
    <Tooltip title={translate("actions.edit")}>
      <Link rel="noopener noreferrer" target="_blank" to={props.path}>
        <LinkEdit size="small">
          <EditIcon fontSize="small" />
        </LinkEdit>
      </Link>
    </Tooltip>
  );
};

export default AdornmentLinkButton;
